import { APIErrorType } from '../../api';
import { StudentQuestionType } from '../../api/student-question';
import { useStudentQuestionFilters } from '../../hooks/index/use-student-question-filters';
import { useLessons } from '../../hooks/react-query/use-lesson';
import { useStudentQuestionsInfiniteQuery } from '../../hooks/react-query/use-student-question';
import Actions from '../exam-review/actions';
import StudentQuestion from '../exam-review/student-question';
import Error from '../shared/error';
import Loader from '../shared/loader';
import Segment from '../shared/segment';
import StudentQuestionsFilter from '../shared/student-exam-filter/filter';
import StudentQuestionsHeader from './student-questions-header';

const QUESTIONS_PER_PAGE = 10;

function StudentQuestions() {
  const { queryParams, panelProps, showAllAnswers } = useStudentQuestionFilters();

  const {
    isError: studentQuestionsIsError,
    error: studentQuestionsError,
    isLoading: studentQuestionsIsLoading,
    data: studentQuestionsData,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage
  } = useStudentQuestionsInfiniteQuery<StudentQuestionType>(queryParams);

  const { data: lessonData } = useLessons();

  if (!lessonData) return null;
  if (studentQuestionsIsError) return <Error error={studentQuestionsError as APIErrorType} />;

  const hasNoResults = studentQuestionsData?.pages[0].count === 0;

  return (
    <div className='mx-2 flex flex-col gap-1'>
      <StudentQuestionsHeader />
      <StudentQuestionsFilter {...panelProps} initialIsOpen={true} lessonData={lessonData} />
      {hasNoResults && (
        <Segment textAlign='center' noMargin>
          <p>بر اساس فیلترهای شما هیچ سوالی یافت نشد</p>
          <p>لطفا فیلترها را تغییر دهید</p>
        </Segment>
      )}

      {studentQuestionsData?.pages.map((page, pageIndex) => (
        <div key={pageIndex}>
          {page.data.map((studentQuestion, questionIndex) => (
            <div key={studentQuestion.id}>
              <StudentQuestion
                studentQuestion={studentQuestion}
                showAllAnswers={showAllAnswers}
                questionNumber={QUESTIONS_PER_PAGE * pageIndex + questionIndex + 1}
                questionCount={page.count}
                showLessonName={true}
              />
            </div>
          ))}
        </div>
      ))}

      {(isFetchingNextPage || studentQuestionsIsLoading || !studentQuestionsData) && (
        <Loader full={false} />
      )}
      <Segment bg noMargin className='mb-36'>
        <Actions hasNextPage={hasNextPage} onFetchNext={fetchNextPage} />
      </Segment>
    </div>
  );
}

export default StudentQuestions;
